// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"479":"e8a17e17","532":"647d9898","982":"61cb8008"}[chunkId] + ".css";
};